var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnicianIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "build_black_24dp 1",
    clipPath: "url(#clip0_1702_5033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.56 1.93997C7.22 0.59997 5.21334 0.326636 3.6 1.1133L6.02 3.5333C6.28 3.7933 6.28 4.2133 6.02 4.4733L4.96 5.5333C4.7 5.79997 4.28 5.79997 4.02 5.5333L1.6 3.1133C0.820002 4.7333 1.09334 6.72664 2.43334 8.06664C3.67334 9.30664 5.48667 9.6333 7.02667 9.0533L12.3333 14.36C13.02 15.0466 14.1267 15.0466 14.8067 14.36C15.4933 13.6733 15.4933 12.5666 14.8067 11.8866L9.52667 6.59997C10.14 5.03997 9.82 3.19997 8.56 1.93997Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1702_5033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicianIcon);
export default __webpack_public_path__ + "static/media/technicianIcon.1e35c057f79191cfccc8daecf2b9de8a.svg";
export { ForwardRef as ReactComponent };